import React from 'react';
import { clsx } from 'clsx';

export interface ContainerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  children: React.ReactNode;
  className?: string;
}

const sizeStyles = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-screen-2xl',
  full: 'max-w-full',
};

export function Container({ size = 'full', children, className }: ContainerProps) {
  return <div className={clsx('mx-auto w-full', sizeStyles[size], className)}>{children}</div>;
}
